import { Box, Typography } from "@mui/joy";

const AddonCartBox = ({
    addons,
    currentAddons,
    currentExtraAddons,
    calculateFinalPriceAddon,
    selected,
    currentPlan,
    calculateDiscountAddon,
}) => {
    return (
        <>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Box minWidth={300}>
                    <Typography level="body-md">
                        {addons?.state[0]?.label} × {currentExtraAddons.state}
                    </Typography>
                    {
                        <Typography level="body-sm" color="neutral">
                            {currentExtraAddons?.state} a pagamento
                        </Typography>
                    }
                    {currentAddons > 0 && (
                        <Typography level="body-sm" color="neutral">
                            Prezzo allineato alla scadenza: {}€
                        </Typography>
                    )}
                </Box>
                <Box minWidth={80} textAlign="right">
                    <Typography
                        level="body-sm"
                        fontWeight="lg"
                        minWidth={60}
                        textAlign="right"
                    >
                        {calculateFinalPriceAddon(120).toFixed(2)}€
                    </Typography>
                </Box>
            </Box>
        </>
    );
};

export default AddonCartBox;
